const loadingEl: Element = document.getElementsByClassName('js-loading')[0];

export class LoadingHelper {
    private static queue: Array<any> = [];
    
    public static start() {
        this.queue.push('');

        if (loadingEl) {
            loadingEl.classList.add('active');
        }
    }

    public static stop() {
        this.queue.pop();

        if (loadingEl && this.queue.length === 0) {
            loadingEl.classList.remove('active');
        }
    }

    public static removeBaseStyle() {
        loadingEl.removeAttribute('style');
    }
}